module.exports = __webpack_public_path__ + "img/1_029.9695c049.jpg";